import { render, staticRenderFns } from "./InterfaceButtonsItem.vue?vue&type=template&id=e9ae648a&scoped=true&"
import script from "./InterfaceButtonsItem.vue?vue&type=script&lang=js&"
export * from "./InterfaceButtonsItem.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceButtonsItem.vue?vue&type=style&index=0&id=e9ae648a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae648a",
  null
  
)

export default component.exports